import "../../assets/css/intro.css";
import "../../assets/css/fonts.css";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { Card, CardDescription, CardTitle } from "../ui/cards";
import { IconExternalLink } from "@tabler/icons-react";
import { motion } from "framer-motion";
import { useState } from "react";
import { emojisplosion } from "emojisplosion";
import deloitteIMG from "../../assets/images/Deloitte.png";

export default function ExperienceTab() {
  const [, setActiveTab] = useState("experience");

  const handleTabClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    tabValue: string,
  ) => {
    setActiveTab(tabValue); // Update the active tab state

    const rect = event.currentTarget.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const startY = rect.top + rect.height / 2; // Start from the center of the tab

    let tabEmojis: string[];
    if (tabValue === "experience") {
      tabEmojis = ["💼", "📈", "💻", "👨‍💻", "👩‍💻"];
    } else if (tabValue === "education") {
      tabEmojis = ["📚", "🎓", "📖", "📝", "🔬"];
    } else {
      tabEmojis = ["✨", "🎉"];
    }

    emojisplosion({
      emojiCount: 5, // Number of emojis to burst
      emojis: tabEmojis,

      physics: {
        initialVelocities: {
          rotation: 0,
          x: {
            min: -5, // Adjust spread horizontally
            max: 5,
          },
          y: {
            min: -5, // Adjust upward velocity
            max: -5,
          },
        },
        gravity: -0.01, // Adjust gravity for a falling effect
        fontSize: 30, // Size of the emojis
        framerate: 40,
      },

      position: () => ({ x: centerX, y: startY }), // Burst from the center of the clicked tab
    });
  };
  return (
    <>
      <div className="bg dark:bg-neutral-950 text-gray-700 dark:text-slate-100 flex items-center justify-center">
        <div className="w-full lg:w-4/6">
          <Tabs defaultValue="experience" className="max-w-screen-xl w-full">
            <TabsList className="w-full justify-between bg-transparent">
              <TabsTrigger
                value="experience"
                className="flex-1"
                onClick={(e) => handleTabClick(e, "experience")}
              >
                Experience
              </TabsTrigger>
              <TabsTrigger
                value="education"
                className="flex-1"
                onClick={(e) => handleTabClick(e, "education")}
              >
                Education
              </TabsTrigger>
            </TabsList>
            <TabsContent value="experience">
              <Card className="bg-slate-50 dark:bg-neutral-900 dark:border-neutral-900">
                <ol className="relative ml-12 mr-12">
                  <div className="absolute top-0 left-0 bottom-0 w-px h-full bg-gray-200 dark:bg-amber-500"></div>
                  <li className="ms-6 py-4">
                    <span className="absolute flex items-center justify-center size-16 mt-2 bg-white rounded-full -start-8 ring-4 ring-white dark:ring-amber-500 dark:bg-white">
                      <img
                        className="shadow-lg rounded-full"
                        src="https://isomer-user-content.by.gov.sg/128/1be4163c-ae45-49ec-8a47-4fc384721287/army-logo.png"
                        alt="Singapore Armed Forces Logo"
                      />
                    </span>
                    <motion.div
                      key={1}
                      className=""
                      initial={{ opacity: 0, x: -10 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: 1 * 0.2 }}
                      viewport={{ amount: 0.1 }}
                    >
                      <div className="items-center justify-between p-4 bg-white border rounded-lg ml-7 shadow-sm sm:flex dark:bg-neutral-800 dark:border-neutral-600">
                        <a
                          href="https://www.army.gov.sg/"
                          target="_blank"
                          rel="noreferrer"
                          className="mb-1 text-xs sm:order-last sm:mb-0 font-semibold"
                        >
                          <IconExternalLink color="grey" />
                        </a>
                        <div className="text-sm font-normal text-gray-500 dark:text-gray-300">
                          <time className="mb-1 text-xs font-normal text-gray-400 ">
                            2024 - 2026
                          </time>
                          <CardTitle>Singapore Armed Forces (SAF)</CardTitle>
                          <CardDescription>
                            <p>Government Administration (Singapore)</p>
                            <p>Full-Time National Servicemen (NSF)</p>
                          </CardDescription>
                          <div className="space-y-0.5 mt-5">
                            <p>Awards: </p>
                            <p>- Commanding Officer Coin (May 2025)</p>
                            <p>- Commanding Officer Coin (September 2025)</p>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </li>
                  <li className="ms-6 py-4">
                    <span className="absolute flex items-center justify-center size-16 mt-2 bg-white rounded-full -start-8 ring-4 ring-white dark:ring-amber-500 dark:bg-white">
                      <img
                        className="shadow-lg size-12"
                        src="https://upload.wikimedia.org/wikipedia/en/7/72/Housing_and_Development_Board_%28logo%29.png"
                        alt="Housing & Development Board Logo"
                      />
                    </span>
                    <motion.div
                      key={2}
                      className=""
                      initial={{ opacity: 0, x: -10 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: 1 * 0.3 }}
                      viewport={{ amount: 0.1 }}
                    >
                      <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg ml-7 shadow-sm sm:flex dark:bg-neutral-800 dark:border-neutral-600">
                        <a
                          href="https://www.hdb.gov.sg/cs/infoweb/homepage"
                          className="mb-1 text-xs sm:order-last sm:mb-0 font-semibold"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <IconExternalLink color="grey" />
                        </a>
                        <div className="text-sm font-normal text-gray-500 dark:text-gray-300">
                          <time className="mb-1 text-xs font-normal text-gray-400 ">
                            Mar 2023 - Mar 2024
                          </time>
                          <CardTitle>
                            Housing & Development Board (HDB)
                          </CardTitle>
                          <CardDescription>
                            <p>Government Administration (Singapore)</p>
                            <p>Intern - UI/UX Engineer</p>
                          </CardDescription>
                          <div className="space-y-0.5 mt-5">
                            <p>
                              - Collaborated with stakeholders, including
                              Product Owners, Scrum Masters, UX Designers, and
                              Engineers, to develop and implement useful
                              features for Singapore Citizens and public
                              officers.
                            </p>
                            <p>
                              - Designed and developed centralized front-end
                              scripts and services to govern the visual
                              consistency of HDB's digital services in the
                              cloud.
                            </p>
                            <p>
                              - Developed and maintained the user interface
                              components of HDB's digital services and the
                              design system.
                            </p>
                            <p>
                              - Conducted research and implemented new
                              frameworks to automate processes and improve
                              workflow efficiency using the latest technology
                              stack.
                            </p>
                            <p>
                              - Utilized Continuous Integration and Continuous
                              Delivery (CI/CD) tools for development automation.
                            </p>
                          </div>
                          <div className="flex flex-wrap gap-2 mt-2 text-white">
                            <span className="px-3 py-1 bg-gray-800 text-sm rounded-lg">
                              <a
                                href="https://www.developer.tech.gov.sg/singapore-government-tech-stack/"
                                target="_blank"
                                rel="noreferrer"
                              >
                                SGTS
                              </a>
                            </span>
                            <span className="px-3 py-1 bg-gray-800 text-sm rounded-lg">
                              TypeScript
                            </span>
                            <span className="px-3 py-1 bg-gray-800 text-sm rounded-lg">
                              React
                            </span>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </li>
                  <li className="ms-6 py-4">
                    <span className="absolute flex items-center justify-center size-16 mt-2 bg-white rounded-full -start-8 ring-4 ring-white dark:ring-amber-500 dark:bg-white">
                      <img
                        className="rounded-full shadow-lg size-14"
                        src={deloitteIMG}
                        alt="Deloitte Logo"
                      />
                    </span>
                    <motion.div
                      key={3}
                      className=""
                      initial={{ opacity: 0, x: -10 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: 1 * 0.4 }}
                      viewport={{ amount: 0.1 }}
                    >
                      <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg ml-7 shadow-sm sm:flex dark:bg-neutral-800 dark:border-neutral-600">
                        <a
                          href="https://www.deloitte.com/southeast-asia/en.html"
                          className="mb-1 text-xs sm:order-last sm:mb-0 font-semibold"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <IconExternalLink color="grey" />
                        </a>
                        <div className="text-sm font-normal text-gray-500 dark:text-gray-300">
                          <time className="mb-1 text-xs font-normal text-gray-400 ">
                            Jan 2021 - Mar 2021
                          </time>
                          <CardTitle>Deloitte</CardTitle>
                          <CardDescription>
                            <p>Accounting Firm (Singapore / SEA)</p>
                            <p>
                              Intern - Marketing & Communications - South East
                              Asia
                            </p>
                          </CardDescription>
                          <div className="space-y-0.5 mt-5">
                            <p>
                              - Maintained web content across South-East Asia
                              (SEA), including both public facing and internal
                              sites (intranet).
                            </p>
                            <p>
                              - Assisted in developing article pages for
                              countries within SEA region.
                            </p>
                            <p>
                              - Coordinated content localization with
                              international teams (such as United States &
                              Luxembourg).
                            </p>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </li>
                  {/* <li className="ms-6 pt-5"></li> */}
                </ol>

                {/* <TimelineLine /> */}
              </Card>
            </TabsContent>

            {/* <<<------------------------------>>*/}

            <TabsContent value="education">
              <Card className="bg-slate-50 dark:bg-neutral-900 dark:border-neutral-900">
                <ol className="relative ml-12 mr-12">
                  <div className="absolute top-0 left-0 bottom-0 w-px h-full bg-gray-200 dark:bg-amber-500"></div>
                  <li className="ms-6 py-4">
                    <span className="absolute flex items-center justify-center size-16 mt-2 bg-white rounded-full -start-8 ring-4 ring-white dark:ring-amber-500 dark:bg-white">
                      <img
                        className="shadow-lg size-14"
                        src="https://dbcsingapore.org/wp-content/uploads/2021/12/SiT.png"
                        alt="Singapore Institue of Technology Logo"
                      />
                    </span>
                    <motion.div
                      key={1}
                      className=""
                      initial={{ opacity: 0, x: -50 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: 1 * 0.2 }}
                      viewport={{ amount: 0.8 }}
                    >
                      <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg ml-5 shadow-sm sm:flex dark:bg-neutral-800 dark:border-neutral-600">
                        <a
                          href="https://www.singaporetech.edu.sg/undergraduate-programmes/computing-science"
                          className="mb-1 text-xs sm:order-last sm:mb-0 font-semibold"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <IconExternalLink color="grey" />
                        </a>
                        <div className="text-sm font-normal text-gray-500 dark:text-gray-300">
                          <time className="mb-1 text-xs font-normal text-gray-400 ">
                            Currently Studying
                          </time>
                          <CardTitle>
                            Singapore Institute of Technology (SIT) & University
                            of Glasgow (UoG)
                          </CardTitle>
                          <CardDescription>
                            <p>BSc (Hons) in Computing Science</p>
                          </CardDescription>
                          <div className="space-y-0.5 mt-5">
                            <p>Graduating in 2029.</p>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </li>
                  <li className="ms-6 py-4">
                    <span className="absolute flex items-center justify-center size-16 mt-2 bg-white rounded-full -start-8 ring-4 ring-white dark:ring-amber-500 dark:bg-white">
                      <img
                        className="rounded-full shadow-lg size-14"
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRDYvv1TKMF9YwcgQZqXY2vJylaHaASQMrLBw&s"
                        alt="Republic Poly Logo"
                      />
                    </span>
                    <motion.div
                      key={2}
                      className=""
                      initial={{ opacity: 0, x: -50 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: 1 * 0.3 }}
                      viewport={{ amount: 0.8 }}
                    >
                      <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg ml-5 shadow-sm sm:flex dark:bg-neutral-800 dark:border-neutral-600">
                        <a
                          href="https://www.rp.edu.sg/SOI/full-time-diplomas/Details/diploma-in-information-technology"
                          className="mb-1 text-xs sm:order-last sm:mb-0 font-semibold"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <IconExternalLink color="grey" />
                        </a>
                        <div className="text-sm font-normal text-gray-500 dark:text-gray-300">
                          <time className="mb-1 text-xs font-normal text-gray-400 ">
                            Apr 2021 - Apr 2024
                          </time>
                          <CardTitle>Republic Polytechnic (RP)</CardTitle>
                          <CardDescription>
                            <p>Diploma in Information Technology</p>
                          </CardDescription>
                          <div className="space-y-0.5 mt-5">
                            <p>Honour & Awards:</p>
                            <p>
                              - Director's Roll of Honour for AY2022 Semester 1
                              & 2
                            </p>
                            <p>
                              - Category Finalist in Polyfintech100 API Hackaton
                              (Decentralized Exchange)
                            </p>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </li>
                  <li className="ms-6 py-4">
                    <span className="absolute flex items-center justify-center size-16 mt-2 bg-white rounded-full -start-8 ring-4 ring-white dark:ring-amber-500 dark:bg-white">
                      <img
                        className="shadow-lg size-10"
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5b/Institute_of_Technical_Education_%28logo%29.svg/1200px-Institute_of_Technical_Education_%28logo%29.svg.png"
                        alt="ITE Logo"
                      />
                    </span>
                    <motion.div
                      key={3}
                      className=""
                      initial={{ opacity: 0, x: -50 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: 1 * 0.4 }}
                      viewport={{ amount: 0.8 }}
                    >
                      <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg ml-5 shadow-sm sm:flex dark:bg-neutral-800 dark:border-neutral-600">
                        <a
                          href="https://www.ite.edu.sg/course-finder/higher-nitec-in-it-applications-development-3-year"
                          className="mb-1 text-xs sm:order-last sm:mb-0 font-semibold"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <IconExternalLink color="grey" />
                        </a>
                        <div className="text-sm font-normal text-gray-500 dark:text-gray-300">
                          <time className="mb-1 text-xs font-normal text-gray-400 ">
                            Jan 2017 - Apr 2021
                          </time>
                          <CardTitle>
                            Institute of Technical Education (ITE)
                          </CardTitle>
                          <CardDescription>
                            <p>Higher Nitec in IT Application Development</p>
                            <p>Nitec in Social Media and Web Development</p>
                          </CardDescription>
                          <div className="space-y-0.5 mt-5">
                            <p>Honour & Awards:</p>
                            <p>- Edusave Merit Bursary Award</p>
                            <p>- Edusave Skills Award</p>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </li>
                </ol>
              </Card>
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </>
  );
}
